const Disclaimer = () => {
  return (
    <div className="legal-page">
      <h1>Disclaimer</h1>

      <p>
        The information provided by EPS Viewer on this website is for general
        informational purposes only. All information on the site is provided in
        good faith; however, we make no representation or warranty of any kind,
        express or implied, regarding the accuracy, adequacy, validity,
        reliability, availability, or completeness of any information.
      </p>

      <h2>1. No Affiliation With Adobe or Other Vendors</h2>
      <p>
        EPS Viewer is an independent tool designed to help users view and
        understand EPS files. We are not affiliated with, endorsed by, or
        associated with Adobe Systems or any other software company mentioned on
        this website. Adobe, Illustrator, Photoshop and PostScript are trademarks
        of Adobe Inc.; CorelDRAW is a trademark of Corel Corporation. All product
        names, logos and brands mentioned on this site are the property of their
        respective owners and are used for identification purposes only.
      </p>

      <h2>2. Conversion Accuracy</h2>
      <p>
        Converting between file formats is not a lossless operation, and results
        depend heavily on how the original file was produced. In particular:
      </p>
      <ul>
        <li>
          EPS is a vector format and PNG and JPG are raster formats. Converting
          to either rasterizes the artwork at a fixed resolution, after which it
          can no longer be enlarged without loss of sharpness.
        </li>
        <li>
          Fonts that were not embedded in the original EPS cannot be reproduced
          faithfully and may be substituted, which can change line breaks,
          spacing and overall appearance.
        </li>
        <li>
          Spot and Pantone colours, overprint settings, clipping paths,
          transparency effects and colour profiles may be approximated, flattened
          or dropped entirely during conversion.
        </li>
        <li>
          Damaged, unusually structured, or non-standard EPS files may fail to
          render, or may render only partially.
        </li>
      </ul>
      <p>
        We therefore make no guarantee that a converted file will be a
        pixel-perfect or colour-accurate reproduction of the original.
        <strong>
          {" "}
          Always review converted output before using it, and do not rely on this
          tool as the sole step in professional print, legal, archival or
          commercial workflows.
        </strong>{" "}
        For colour-critical print work, verify the result against the original in
        professional software and request a proof from your printer.
      </p>

      <h2>3. Keep Your Original Files</h2>
      <p>
        Uploaded files and their generated outputs are removed from our servers
        after processing, and EPS Viewer is not a storage or backup service. You
        are responsible for retaining your own copy of any original artwork. We
        cannot recover, restore or re-supply a file once processing has finished.
      </p>

      <h2>4. Use at Your Own Risk</h2>
      <p>
        Any action you take upon the information you find on this website is
        strictly at your own risk. EPS Viewer will not be liable for any losses
        and/or damages in connection with the use of our website or services,
        including any loss arising from reliance on a converted file.
      </p>

      <h2>5. Guides and Tutorials</h2>
      <p>
        Our guides describe software, operating systems and file formats that
        change over time. Menu names, keyboard shortcuts and export options may
        differ between versions, and instructions that were accurate when written
        may become outdated. Nothing in our guides constitutes professional
        design, prepress or legal advice.
      </p>

      <h2>6. External Links</h2>
      <p>
        From our website, you may visit other websites by following hyperlinks
        to such external sites. While we strive to provide only quality links,
        we have no control over the content and nature of these sites. These
        links do not imply a recommendation for all the content found on these
        sites, and we are not responsible for their content, privacy practices,
        or availability.
      </p>

      <h2>7. Service Availability</h2>
      <p>
        EPS Viewer is provided free of charge on an &quot;as is&quot; and
        &quot;as available&quot; basis. We do not guarantee uninterrupted access,
        and features, file-size limits and supported formats may change or be
        withdrawn at any time without notice.
      </p>

      <p>
        By using our website, you hereby consent to our disclaimer and agree to
        its terms. If you do not agree, please discontinue use of the site. For
        questions about this disclaimer, contact us at{" "}
        <a href="mailto:support@magicapps.co.in">support@magicapps.co.in</a>.
      </p>
    </div>
  );
};

export default Disclaimer;
